import { getCurrentMerchantUser as getCurrentMerchantAccount } from 'api/rest/merchantAccount/getCurrentMerchantUser';
import { getDataAtom } from 'utils/atoms/dataAtom';
import { getDataFetchingAtom } from 'utils/atoms/dataFetchingAtom';

import { Merchant } from '../models';

export const currentMerchantAccountAtom = getDataAtom<Merchant>();

export const fetchCurrentMerchantAccountAtom = getDataFetchingAtom<
  Merchant,
  undefined
>(currentMerchantAccountAtom, getCurrentMerchantAccount);
